import { NAME } from "./constants";
const _ = require("lodash");

export const isLoading = (state) => {
  return state.pages[NAME].isLoading;
};

export const getActiveTab = (state) => {
  return state.pages[NAME].activeTab;
};

export const getCrowdContentOrders = (state) => {
  return state.pages[NAME].contentOrders.ordersArray;
};

export const getPlacedCrowdContentOrders = (state) => {
  let placedOrders = state.pages[NAME].contentOrders.ordersArray.filter(
    (order) => {
      return (
        order.status === "1" || order.status === "2" || order.status === "3"
      );
    }
  );
  const sortedOrders = _.orderBy(placedOrders, "order_id", "asc");
  return sortedOrders;
};

export const getPlacedCrowdContentOrdersFiltered = (state) => {
  const filterName = state.pages[NAME].contentOrdersFilter.filterName;

  let placedOrders = state.pages[NAME].contentOrders.ordersArray.filter(
    (order) => {
      return (
        order.status === "1" || order.status === "2" || order.status === "3"
      );
    }
  );
  const sortedOrders = _.orderBy(placedOrders, "order_id", "asc");

  if (filterName) {
    return sortedOrders.filter(order =>
      order.meta?.project?.meta?.parent?.local?.business?.name?.trim() === filterName
    );
  }

  return sortedOrders;
};

export const getReadyForReviewCrowdContentOrders = (state) => {
  let ordersReadyForReview = state.pages[NAME].contentOrders.ordersArray.filter(
    (order) => {
      return order.status === "4";
    }
  );
  return ordersReadyForReview;
};

export const getReadyForReviewCrowdContentOrdersFiltered = (state) => {
  const filterName = state.pages[NAME].contentOrdersFilter.filterName;

  let ordersReadyForReview = state.pages[NAME].contentOrders.ordersArray.filter(
    (order) => {
      return order.status === "4";
    }
  );

  if (filterName) {
    return ordersReadyForReview.filter(order =>
      order.meta?.project?.meta?.parent?.local?.business?.name?.trim() === filterName
    );
  }

  return ordersReadyForReview;
};

export const getCrowdContentOrdersThatNeedPosting = (state) => {
  let ordersReadyForPosting = state.pages[
    NAME
  ].contentOrders.ordersNeedingPosting.filter((order) => {
    return order.crowdContent.status.status_ID === "69";
  });
  return ordersReadyForPosting;
};

export const getCrowdContentOrdersThatNeedPostingFiltered = (state) => {
  const filterName = state.pages[NAME].contentOrdersFilter.filterName;

  let ordersReadyForPosting = state.pages[
    NAME
  ].contentOrders.ordersNeedingPosting.filter((order) => {
    return order.crowdContent.status.status_ID === "69";
  });

  if (filterName) {
    return ordersReadyForPosting.filter(order =>
      order.meta.project.meta.parent.local.business.name.trim() === filterName
    );
  }

  return ordersReadyForPosting;
};

export const getRecentlyPublishedCrowdContentOrders = (state) => {
  let recentlyPublishedContentOrder = state.pages[
    NAME
  ].contentOrders.ordersRecentlyPublished.filter((order) => {
    return order.crowdContent.status.status_ID === "420";
  });
  return recentlyPublishedContentOrder;
};

export const getRecentlyPublishedCrowdContentOrdersFiltered = (state) => {
  const filterName = state.pages[NAME].contentOrdersFilter.filterName;

  let recentlyPublishedContentOrder = state.pages[
    NAME
  ].contentOrders.ordersRecentlyPublished.filter((order) => {
    return order.crowdContent.status.status_ID === "420";
  });

  if (filterName) {
    return recentlyPublishedContentOrder.filter(order =>
      order.meta.project.meta.parent.local.business.name.trim() === filterName
    );
  }

  return recentlyPublishedContentOrder;
};

// export const getRecentlyPublishedContentOrders = (state) => {
//   const sortedArray = state.pages[NAME].contentOrders.recentlyPublished;
//   sortedArray.sort(function compare(a, b) {
//     var dateA = new Date(a.meta.publishedOn);
//     var dateB = new Date(b.meta.publishedOn);
//     return dateB - dateA;
//   });
//   return sortedArray;
// };

export const getFilterName = (state) => {
  return state.pages[NAME].contentOrdersFilter.filterName;
}
